module.exports = __webpack_public_path__ + "static/media/carousel3.e045c04c.png";